/* Перемикач валют застосунку Doubly живе у шапці, а не плаває в кутку.
   На десктопі — поруч із вибором мови, на телефоні — на дні бургер-меню.
   Віджет переносимо, а не клонуємо: клон втратив би обробники застосунку. */
(function () {
  var DESKTOP = '(min-width: 990px)';

  function slot() {
    var wide = window.matchMedia(DESKTOP).matches;
    return document.querySelector(wide ? '.desktop-localization-wrapper' : '.menu-drawer__localization');
  }

  function place() {
    var widget = document.querySelector('.doubly-float');
    var target = slot();
    if (!widget || !target) return false;
    if (widget.parentElement !== target) target.insertBefore(widget, target.firstChild);
    document.documentElement.classList.add('kn-currency-in-header');
    return true;
  }

  function boot() {
    /* застосунок домальовує віджет асинхронно — чекаємо, але не вічно */
    if (place()) return;
    var tries = 0;
    var timer = setInterval(function () {
      if (place() || ++tries > 40) clearInterval(timer);
    }, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.addEventListener('resize', place);
})();